import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { TJobRenderComponentProps } from '@/console/features/jobs/components/jobs-list/jobs-list-renderer.types';
import { TextButton } from '@/shared/components/ui/button/text-button/text-button';
import { usePermissions } from '@/shared/features/ability/hooks/use-permissions/use-permissions';
import { useReadPipelineQuery } from '@/shared/redux/api/jobs/jobs-api';
import { JobSourceEnum } from '@/shared/types/types.generated';
import { formatShortId } from '@/shared/utils/format';

export const JobExecutionId: React.FC<TJobRenderComponentProps> = ({ job }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const canReadPipeline = usePermissions({
    entity: 'Pipeline',
    action: 'read',
    attribute: { id: job?.pipelineConfigurationId },
  });
  const { data: pipelineData } = useReadPipelineQuery(
    { pipelineConfigurationId: job?.pipelineConfigurationId! },
    {
      skip:
        !job?.pipelineConfigurationId ||
        job?.source !== JobSourceEnum.Pipeline ||
        !canReadPipeline,
    },
  );

  const pipeline = pipelineData?.readPipelineConfiguration;

  if (!job?.pipelineExecutionId) {
    return null;
  }

  const getTooltipText = () => {
    if (!pipeline) {
      return '';
    }
    return `${t('pipelines:open_pipeline_execution')}: ${pipeline.name}`;
  };

  return (
    <TextButton
      variant="secondary"
      tooltip={getTooltipText()}
      onClick={(e) => {
        e.stopPropagation();
        navigate(`/pipelines/${job?.pipelineConfigurationId}/executions`);
      }}
      disabled={!pipeline}
    >
      {formatShortId(job?.pipelineExecutionId!)}
    </TextButton>
  );
};
